export enum SplitFlags {
  MOCK_FLAG = 'mock-flag', // for use in unit tests that require `SplitFlags` but that aren't coupled to a specific feature flag
  CH_E3 = 'ch-exos-employer-experience',
  CH_SERVICE_BOOKING = 'ch-service-booking',
}
